import * as React from 'react';
import {
    BooleanField,
    Button,
    CardActions,
    DateField,
    NumberField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField,
    translate,
} from 'react-admin';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {Link} from 'react-router-dom';

const GROUPS = {
    'Thông tin chung': [
        {s: 'id', t: 'number'},
        {s: 'status'}, {s: 'message'},
        {s: 'MA_PHONG_GD'}, {s: 'MA_TRUONG'},
        {s: 'MA_NAM_HOC', t: 'number'}, {s: 'MA_CAP_HOC'},
        {s: 'ID_LOP', t: 'number'}, {s: 'MA_LOP'}, {s: 'MA_SO_GD'}, {s: 'MA_KHOI'},
        {s: 'MA_HS'}, {s: 'MA_BO'}, {s: 'MA_SO_DINH_DANH_CA_NHAN'},
        {s: 'HO_TEN'}, {s: 'HO_DEM'}, {s: 'TEN_DEM'},
        {s: 'NGAY_SINH', t: 'date'}, {s: 'MA_GIOI_TINH'}, {s: 'MA_DAN_TOC'}, {s: 'MA_QUOC_TICH'},
    ],
    'Địa chỉ/Quê quán': [
        {s: 'CHO_O_HIEN_NAY'}, {s: 'CHO_O_HIEN_NAY_MA_TINH'}, {s: 'CHO_O_HIEN_NAY_MA_HUYEN'}, {s: 'CHO_O_HIEN_NAY_MA_XA'},
        {s: 'NOI_SINH'}, {s: 'NOI_SINH_MA_TINH'}, {s: 'NOI_SINH_MA_HUYEN'}, {s: 'NOI_SINH_MA_XA'},
        {s: 'QUE_QUAN'}, {s: 'QUE_QUAN_MA_TINH'}, {s: 'QUE_QUAN_MA_HUYEN'}, {s: 'QUE_QUAN_MA_XA'},
        {s: 'QUE_QUAN_TO_THON'}, {s: 'NOI_DANG_KY_KHAI_SINH_MA_TINH'},
        {s: 'MA_DIA_PHUONG'}, {s: 'MA_TON_GIAO'},
        {s: 'TAM_TRU_ID_HUYEN'}, {s: 'TAM_TRU_MA_HUYEN'}, {s: 'TAM_TRU_ID_XA'}, {s: 'TAM_TRU_MA_XA'},
    ],
    'Cha/Mẹ/Người đại diện': [
        {s: 'TEN_CHA'}, {s: 'MA_SO_DINH_DANH_CA_NHAN_CHA'}, {s: 'NGHE_NGHIEP_CHA'}, {s: 'NAM_SINH_CHA', t: 'number'},
        {s: 'TEN_ME'}, {s: 'MA_SO_DINH_DANH_CA_NHAN_ME'}, {s: 'NGHE_NGHIEP_ME'}, {s: 'NAM_SINH_ME', t: 'number'},
        {s: 'TEN_NGUOI_DD'}, {s: 'MA_SO_DINH_DANH_CA_NHAN_NGUOI_DD'}, {s: 'NGHE_NGHIEP_NGUOI_DD'}, {
            s: 'NAM_SINH_NGUOI_DO_DAU',
            t: 'number'
        },
        {s: 'MA_GIOI_TINH_CHA'}, {s: 'MA_GIOI_TINH_ME'}, {s: 'MA_GIOI_TINH_NGUOI_DD'},
        {s: 'HO_TEN_NGUOI_NHAN_TIN'},
    ],
    'Trạng thái học tập': [
        {s: 'MA_TRANG_THAI_K1'}, {s: 'MA_TRANG_THAI_K2'}, {s: 'MA_TRANG_THAI_HIEN_TAI'},
        {s: 'NGAY_TRANG_THAI', t: 'date'}, {s: 'MA_LY_DO_THOI_HOC'}, {s: 'THU_TU', t: 'number'},
        {s: 'MA_HINH_THUC_HOC_TAP'}, {s: 'MA_LOP_GHEP'}, {s: 'MA_SO_BUOI_HOC_TREN_TUAN'}, {s: 'MA_HOC_BAN_TRU'},
        {s: 'IS_HOC_2_BUOI', t: 'number'}, {s: 'IS_HOC_LOP_MG_5T', t: 'number'}, {s: 'IS_TUYEN_MOI_MN', t: 'number'},
        {s: 'IS_DANG_HOC_K1', t: 'number'}, {s: 'IS_DANG_HOC_K2', t: 'number'}, {
            s: 'IS_HOC_SINH_LOP_BTRU',
            t: 'number'
        },
        {s: 'TEN_TAT'}, {s: 'MA_HO_SO_CHUAN'},
    ],
    'Chính sách/Hỗ trợ': [
        {s: 'MA_DIEN_CHINH_SACH'}, {s: 'MA_MIEN_GIAM_HOC_PHI'}, {s: 'MA_LOAI_KHUYET_TAT'},
        {s: 'IS_KHUYET_TAT_KHONG_DANH_GIA', t: 'bool'}, {s: 'IS_HOC_SINH_BAN_TRU_DAN_NUOI', t: 'bool'},
        {s: 'IS_HOC_SINH_TIENG_DAN_TOC', t: 'bool'}, {s: 'IS_HOC_SONG_NGU', t: 'bool'},
        {s: 'IS_HO_NGHEO', t: 'bool'}, {s: 'IS_VUNG_KK', t: 'bool'},
        {s: 'IS_HOAN_THANH_CHUONG_TRINH_MAM_NON', t: 'bool'},
        {s: 'IS_MIEN_HOC_PHI', t: 'bool'}, {s: 'IS_GIAM_HOC_PHI', t: 'bool'}, {
            s: 'IS_HO_TRO_CHI_PHI_HOC_TAP',
            t: 'bool'
        },
        {s: 'IS_CAP_TIEN_HANG_THANG', t: 'bool'}, {s: 'IS_CAP_GAO', t: 'bool'}, {s: 'IS_HO_TRO_NHA_O', t: 'bool'},
        {s: 'IS_HOC_CTGD_CUA_BO', t: 'bool'}, {s: 'IS_HO_TRO_AN_TRUA', t: 'bool'},
        {s: 'IS_HOC_CHUONG_TRINH_LAM_QUEN_NN', t: 'bool'}, {
            s: 'IS_PH_CO_SMARTPHONE',
            t: 'bool'
        }, {s: 'IS_PH_CO_MAY_TINH_INTERNET', t: 'bool'},
        {s: 'IS_HOC_SINH_NTRU_DAN_NUOI', t: 'bool'}, {
            s: 'IS_KHUYET_TAT_CAN_THIEP_SOM',
            t: 'bool'
        }, {s: 'IS_KHUYET_TAT_GIAY_XAC_NHAN', t: 'bool'},
        {s: 'IS_NHU_CAU_HO_TRO_NNGU', t: 'bool'}, {s: 'IS_TANG_CUONG_TVIET', t: 'bool'},
        {s: 'IS_TU_VAN_GIAO_DUC_HUONG_NGHIEP', t: 'bool'},
    ],
    'Sức khỏe kỳ 1': [
        {s: 'CAN_NANG_KY1', t: 'number'}, {s: 'CHIEU_CAO_KY1', t: 'number'}, {s: 'BMI_KY1', t: 'number'},
        {s: 'MA_DANH_GIA_BMI_KY1'}, {s: 'SUC_KHOE_KY1'},
        {s: 'HUYET_AP_TAM_TRUONG_K1'}, {s: 'HUYET_AP_TAM_THU_K1'}, {s: 'NHIP_TIM_K1'},
        {s: 'THI_LUC_MAT_TRAI_KHONG_KINH_K1'}, {s: 'THI_LUC_MAT_PHAI_KHONG_KINH_K1'},
        {s: 'THI_LUC_MAT_TRAI_CO_KINH_K1'}, {s: 'THI_LUC_MAT_PHAI_CO_KINH_K1'},
        {s: 'IS_BIET_BOI_KY1', t: 'bool'},
    ],
    'Sức khỏe kỳ 2': [
        {s: 'CAN_NANG_KY2', t: 'number'}, {s: 'CHIEU_CAO_KY2', t: 'number'}, {s: 'BMI_KY2', t: 'number'},
        {s: 'MA_DANH_GIA_BMI_KY2'}, {s: 'SUC_KHOE_KY2'},
        {s: 'HUYET_AP_TAM_TRUONG_K2'}, {s: 'HUYET_AP_TAM_THU_K2'}, {s: 'NHIP_TIM_K2'},
        {s: 'THI_LUC_MAT_TRAI_KHONG_KINH_K2'}, {s: 'THI_LUC_MAT_PHAI_KHONG_KINH_K2'},
        {s: 'THI_LUC_MAT_TRAI_CO_KINH_K2'}, {s: 'THI_LUC_MAT_PHAI_CO_KINH_K2'},
        {s: 'IS_BIET_BOI_KY2', t: 'bool'},
    ],
    'Điểm danh/Ghi chú': [
        {s: 'SO_NGAY_NGHI_CO_PHEP', t: 'number'}, {s: 'SO_NGAY_NGHI_KHONG_PHEP', t: 'number'},
        {s: 'SO_BUOI_SANG_NGHI_CO_PHEP', t: 'number'}, {s: 'SO_BUOI_SANG_NGHI_KHONG_PHEP', t: 'number'},
        {s: 'SO_BUOI_CHIEU_NGHI_CO_PHEP', t: 'number'}, {s: 'SO_BUOI_CHIEU_NGHI_KHONG_CO_PHEP', t: 'number'},
        {s: 'NHAN_XET_GVCN'}, {s: 'NHAN_XET_GVCN1'}, {s: 'PHE_DUYET_HIEU_TRUONG'},
    ],
    'Khác': [
        {s: 'MA_KHU_VUC'}, {s: 'MA_NHOM_MAU'}, {s: 'TEN_TAT'}, {s: 'MA_BENH_VE_MAT'},
        {s: 'SO_DANG_BO'}, {s: 'DAN_TOC_THEO_GIAY_KHAI_SINH'},
        {s: 'CC_NGHE_PHO_THONG'}, {s: 'MA_LOAI_CC_NGHE_PHO_THONG'},
    ],
};

const makeRenderField = (t) => ({s, t: typ}) => {
    const label = t(`resources.eduDatas.fields.${s}`, {_: s});
    const common = {source: s, label, key: s};
    if (s === 'id') {
        return <TextField {...common} />;
    }
    switch (typ) {
        case 'number':
            return <NumberField {...common} />;
        case 'bool':
            return <BooleanField {...common} />;
        case 'date':
            return <DateField {...common} showTime={false} locales="vi-VN"/>;
        default:
            return <TextField {...common} />;
    }
};

const cardActionStyle = {
    justifyContent: 'flex-start'
};


const PostShowActions = ({basePath = '/eduDatas'}) => (
    <CardActions style={cardActionStyle}>
        <Button component={Link} to={basePath}>
            <>
                <ArrowBackIcon style={{marginRight: 8}}/>
                Về danh sách
            </>
        </Button>
    </CardActions>
);

const EduDataShow = (props) => {
    const {translate: t} = props;
    const renderField = makeRenderField(t);

    return (<Show {...props} actions={<PostShowActions/>}>
        <TabbedShowLayout>
            {Object.entries(GROUPS).map(([tabLabel, fields]) => (<Tab key={tabLabel} label={tabLabel}>
                {fields.map(renderField)}
            </Tab>))}
        </TabbedShowLayout>
    </Show>);
};

export default translate(EduDataShow);
